import theme from "@/constants/theme";

export const styles: Record<string, React.CSSProperties> = {
  contentContainer: {
    flex: 1,
    gap: 8,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "inherit",
    maxHeight: "100%",
    overflow: "auto",
    paddingTop: 16,
    paddingBottom: 16,
  },
  title: {
    color: theme.colors.text.title,
  },
};
